import { z } from "zod";

export const countryTypeSchema = z.object({
	countryCode: z.string(),
	countryName: z.string(),
	slug: z.string(),
	internationalCallingCode: z.string(),
	allowedAreaCodes: z.array(z.number()).optional(),
	localPhoneNumberLength: z.array(z.number()),
	currencyCode: z.string()
})

export type CountryType = z.infer<typeof countryTypeSchema>
